var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":"/img/icons/supplier.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }